import React from 'react';
import AppLayout from '../../layout/app.layout';

import PAGE_TITLE_LIST from '../../config/page-title.config';
import ListDataChangeLogs from '../../components/reports/list-data-change-logs-component';

const DataChangeLogsView = () => {
  const pageTitle = PAGE_TITLE_LIST.DATA_CHANGE_LOGS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListDataChangeLogs />
    </AppLayout>
  );
};

export default DataChangeLogsView;
